import React, { useEffect, useState } from "react";
import { Card, Grid, Typography, Button } from "@mui/material";
import DemoParinted from "../../../../../templates/ApplicationDetails/components/RichTextArea";
import InputWrapper from "../../citizen/AVPForms/layout/inputWrapper";
import { useForm } from "react-hook-form";
import RemarksEditor from "../../../../../templates/ApplicationDetails/components/EmpReusableComp/RemarksEditor";
// import { remarks } from "../../citizen/TCPForms/data";
import { Toast } from "@egovernments/digit-ui-react-components";
import { useTranslation } from "react-i18next";
import { innerInspRecommendation } from "../../citizen/TCPForms/data";

const RecommendationRemarksComponent = ({
  title,
  label,
  name,
  names,
  control, // from parent (optional)
  options,
  defaultValue,
  extraLabel,
  setDeveloperRemarks,
  developerRemarks,
  setDataRecommendation,
  optionsInner,
  buttonshow = false,
  setSelectedObjection,
  type,
  onSaveClick,
  error,
  setError,
  handleTabChange,
  nextTab,
  isFromDashboard,
}) => {
  // If control not passed and buttonshow true, use local form instance\
  const { t } = useTranslation();
  const { control: localControl, handleSubmit, setValue: localSetValue, getValues } = !control && buttonshow ? useForm() : {};
  const [selectedName, setSelectedName] = useState(null);
  const [showToast, setShowToast] = useState(null);
  const [selectedRecommendationName, setSelectedRecommendationName] = useState(null);
  console.log(selectedRecommendationName, "selectedRecommendationName");
  
  const handleRecommendationChange = (e) => {
    const value = e?.target?.value;
    console.log("Manual select value:", value);
    if(!value){
    
    }
    setDataRecommendation?.(value);
    setSelectedRecommendationName(value);
  };

  useEffect(() => {
  console.log("Toast updated:", showToast);
}, [showToast]);

  const handleRecommendationChanges = (e) => {
    const value = e?.target?.value;
    console.log("Manual select value:", value);
    if(!value){
      setError("This field is required");
      return;
    }
    setSelectedName?.(value);
    setSelectedObjection?.(value);
  };

 
  const handleClick = () => {
    const selectedValue = getValues?.(name); // recommendation
    const selectedValue2 = getValues?.(names); // objection(s)

    console.log("Selected Value from local form:", selectedValue, selectedValue2,developerRemarks);

    if(!developerRemarks || developerRemarks.trim() === ""){
      setError(true);
      return;
    }

    if(!selectedValue || selectedValue.trim() === ""){
   
      console.log("No recommendation selected",showToast);
      setShowToast({ error: true, label: "Please Select Recommendation" });
      return;
    }
    setDataRecommendation?.(selectedValue || "static-recommendation");
    setSelectedObjection?.(selectedValue2 || "static-recommendation");

    if (onSaveClick) {
      onSaveClick(selectedValue, selectedValue2); // ✅ Pass both values
      setDeveloperRemarks(null); // Clear remarks after save
      setDataRecommendation?.(""); // Clear recommendation after save
      handleTabChange?.(nextTab); // Move to next tab
    }
  };

  // console.log("defaultValue12", defaultValue, selectedName);
  // console.log(innerInspRecommendation,"optionsInner", optionsInner);

  const finalControl = control ? control : localControl;

  return (
    <Card sx={{ backgroundColor: "#f9f9f9", boxShadow: "0 4px 8px rgba(0, 0, 0, 0.2)", my: 2, p: 2 }}>
      <Typography
        variant="h6"
        sx={{
          background: "linear-gradient(to right, #1E73BE, #E3F2FD)",
          p: 1,
          color: "#fff",
          textAlign: "left",
          borderRadius: "4px",
          fontSize: "1rem",
          padding: "10px",
          fontFamily: "sans-serif",
          lineHeight: "1.5",
        }}
      >
        {title}
      </Typography>
      {/* Main Field */}
      <Grid container spacing={1} sx={{ my: 2 }}>
        <Grid item xs={3}>
          <Typography>
            {label}
            <span style={{ color: "red" }}> *</span>
          </Typography>
        </Grid>
        <Grid item xs={8}>
          {control ? (
            <InputWrapper
              control={finalControl}
              name={name}
              type="selectInput"
              data={options}
              defaultValue={defaultValue}
              hasLabel={false}
              validation={{
                required: {
                  value: true,
                  message: "This field is required",
                },
              }}
            />
          ) : (
            <InputWrapper
              name={name}
              control={finalControl}
              type="selectInput"
              data={options}
              defaultValue={defaultValue}
              hasLabel={false}
              onBlur={handleRecommendationChange}
              error={error}
              setError={setError}
              // onChange={handleRecommendationChange}
              validation={{
                required: {
                  value: true,
                  message: "This field is required",
                },
              }}
            />
          )}
          {showToast && (
                    <Toast
                      isDleteBtn={true}
                      error={showToast.error}
                      warning={showToast.warning}
                      label={t(showToast.label)}
                      onClose={() => {
                        setShowToast(null);
                      }}
                    />
                  )}
        </Grid>
      </Grid>
      {/* selectedName === "Shortfall" && */}
      {type === "drawingDetails" && (selectedRecommendationName === "Shortfall" || defaultValue === "Shortfall")  && (
        <Grid container spacing={1} sx={{ my: 2 }}>
          <Grid item xs={3}>
            <Typography>
              Objection<span style={{ color: "red" }}> *</span>
            </Typography>
          </Grid>
          <Grid item xs={8}>
            <InputWrapper
              name={names}
              type="multiSelectInput"
              control={finalControl}
              placeholder="Select options"
                data={innerInspRecommendation || []}
  defaultValue={selectedName ? [selectedName] : []}
              // data={optionsInner}
              // defaultValue={[selectedName]}
              onBlur={handleRecommendationChanges}
              validation={{
                required: {
                  value: true,
                  message: "This field is required",
                },
              }}
            />
        
          </Grid>
        </Grid>
      )}
      {/* Developer Remarks */}
      <Grid container spacing={1} sx={{ my: 2 }}>
        <Grid item xs={3}>
          <Typography>
            {extraLabel}
            <span style={{ color: "red" }}> *</span>
          </Typography>
        </Grid>
        <Grid item xs={8}>
          <RemarksEditor setRemarks={setDeveloperRemarks} remarks={developerRemarks} error={error} setError={setError} />
        </Grid>
      </Grid>
      {/* Save Button */}
      {buttonshow && !isFromDashboard && (
        // <Grid container justifyContent="flex-end">
        //   <Button variant="contained" >
        //     Save
        //   </Button>
        // </Grid>
        <div style={{ textAlign: "center", marginTop: "24px" }}>
          <Button
            variant="contained"
            color="secondary"
            onClick={handleClick}
            style={{ margin: "auto", height: "30px", width: "10%", borderRadius: "4px", backgroundColor: "#157CB3" }}
          >
            Save
          </Button>
        </div>
      )}
          
    </Card>
  );
};

export default RecommendationRemarksComponent;
